<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <!-- <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="路线名称">
          <el-input placeholder="请输入路线名称" v-model="formInline.search">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form> -->
      <el-form :inline="true" size="small" :model="formInline">
        <el-form-item label="路线名称">
          <el-input v-model="formInline.search" placeholder="请输入路线名称" />
        </el-form-item>

        <!-- <el-form-item label="路线类别">
          <el-cascader
            v-model="formInline.route_category_ids"
            placeholder="请选择路线类别"
            :options="categoryOptions"
            :props="{ multiple: true, emitPath: false, value: 'route_category_id', label: 'name', children: 'children', checkStrictly: true }"
            clearable
            @change="onCategoryChange"
          ></el-cascader>
        </el-form-item> -->

    

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加路线</el-button
      >
    </div>

    <!-- 显示/隐藏路线切换 -->
    <div class="common-level-rail" style="margin-bottom: 15px;">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange" type="card">
        <el-tab-pane label="显示路线" name="show"></el-tab-pane>
        <el-tab-pane label="隐藏路线" name="hide"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="sort" label="序号" width="100">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.sort"
                  :min="0"
                  :max="999"
                  size="mini"
                  controls-position="right"
                  @change="handleSortChange(scope.row)"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="路线名称"></el-table-column>

            <!-- 价格 -->
            <el-table-column prop="price" label="价格">
              <template slot-scope="scope">
                {{ scope.row.price }}元
              </template>
            </el-table-column>

            <!-- 集合地 -->
            <el-table-column prop="address" label="集合地"></el-table-column>
            <!-- 目的地 -->
            <el-table-column
              prop="destination"
              label="目的地"
            ></el-table-column>

            <!-- 行程安排 -->
            <el-table-column prop="schedule" label="行程安排" width="180">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.schedule"
                  placement="top"
                >
                  <span class="text-ellipsis">{{
                    scope.row.schedule | truncate(30)
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 费用说明 -->
            <el-table-column prop="fee_exp" label="费用说明" width="180">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.fee_exp"
                  placement="top"
                >
                  <span class="text-ellipsis">{{
                    scope.row.fee_exp | truncate(30)
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 注意事项 -->
            <el-table-column prop="remark" label="注意事项" width="180">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.remark"
                  placement="top"
                >
                  <span class="text-ellipsis">{{
                    scope.row.remark | truncate(30)
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 联系人 -->
            <el-table-column prop="liaison" label="联系人"></el-table-column>

            <!-- 最近报名 -->
            <el-table-column
              prop="recent_sign"
              label="最近报名"
            ></el-table-column>

            <!-- 活动介绍 -->
            <el-table-column prop="intro" label="活动介绍" width="180">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.intro"
                  placement="top"
                >
                  <span class="text-ellipsis">{{
                    scope.row.intro | truncate(30)
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="copyData(scope.row)" type="text" size="small"
                  >一键复制</el-button
                >
                <!-- <el-button v-if="scope.row.recommend == 0" @click="recommend(scope.row)" type="text" size="small">推荐</el-button> -->
                <el-button @click="hide(scope.row)" type="text" size="small">
                  {{ scope.row.is_hide == 1 ? "显示" : "隐藏" }}
                </el-button>
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :route_id="route_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import RouteApi from "@/api/route.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: "",
        route_category_ids: [],
        region_id: ""
      },
      categoryOptions: [], // 路线类别
      provinceOptions: [], // 省份
      open_add: false,
      open_edit: false,
      route_id: "",
      dialogVisible: false,
      activeTab: "show" // 当前选中的tab：show-显示路线，hide-隐藏路线
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
    this.getCategoryOptions();
    this.getProvinceOptions();
  },
  methods: {
    // 路线类别改变
    onCategoryChange(categoryIds) {
      // 清空二级
      this.formInline.region_id = "";
      this.provinceOptions = [];

      if (!categoryIds || categoryIds.length === 0) return;

      // ✅ 加载省份
      this.getProvinceOptions();
    },
    // 获取路线类别
    getCategoryOptions() {
      RouteApi.categoryOptions().then(res => {
        this.categoryOptions = res.data.list.data;
      });
    },

    // 获取省份
    getProvinceOptions() {
      RouteApi.provinceOptions().then(res => {
        this.provinceOptions = res.data;
      });
    },
    copyData(item) {
      let self = this;
      self
        .$confirm("是否复制?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "数据复制中请等待",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          RouteApi.copy({ route_id: item.route_id }, true)
            .then(res => {
              console.log(res);
              loading.close();
              this.getTableList();
              this.$message.success("复制成功！");
            })
            .catch(error => {
              setTimeout(() => {
                loading.close();
                this.$message.success("操作失败！");
              }, 2000);
            });
        });
    },

    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //路线标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      if (!this.formInline.route_category_ids || this.formInline.route_category_ids.length === 0) {
        this.$message.warning("请选择路线类别");
        return;
      }

      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      // 根据选中的tab设置is_hide参数
      Params.is_hide = this.activeTab === "show" ? 0 : 1;
      self.loading = true;
      RouteApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*tab切换*/
    handleTabChange() {
      this.curPage = 1;
      this.getTableList();
    },

    /*修改排序*/
    handleSortChange(row) {
      RouteApi.editx({
        route_id: row.route_id,
        sort: row.sort
      }, true).then(() => {
        this.$message.success('排序修改成功');
      }).catch(() => {
        this.$message.error('排序修改失败');
      });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.route_id = row.route_id;
      this.open_edit = true;
    },
    // recommend(row){
    //   RouteApi.edit({route_id :row.route_id})
    //   .then(data => {
    //       this.$message({
    //               message: '推荐成功',
    //               type: 'success'
    //             });
    //     })
    // },
    /*隐藏 / 显示*/
    hide(row) {
      let self = this;
      let tip = row.is_hide == 1 ? "显示" : "隐藏";

      self
        .$confirm(`确认${tip}该路线？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          RouteApi.hide({
            route_id: row.route_id
          })
            .then(data => {
              if (data.code == 1) {
                // ✅ 立即反转状态，不用等刷新
                row.is_hide = row.is_hide == 1 ? 0 : 1;
                self.$message.success(`${tip}成功`);
              } else {
                self.$message.error(`${tip}失败`);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          RouteApi.del(
            {
              route_id: row.route_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/route/index/index.vue